import styles from './styles.module.sass';

/**
 * Social media links (facebook, twitter, etc.)
 * LinkComponent is used for rendering the link. If it's not provided fallback to HTMLAnchorElement
 */
export const SocialLinks = ({ links, LinkComponent }: { links: any; LinkComponent?: any }) => (
    <div className={styles.socialLinks}>
        {links.map((link: { link: any; target: any; image: string | undefined; alt: any }, index: string) => {
            const props = {
                href: link.link,
                target: link.target,
                children: <img src={link.image} alt="" />,
                'data-test-id': `footer-social-link-${link.alt?.toLowerCase().replace(/\s+/g, '-') || index}`,
            };

            return LinkComponent ? (
                <LinkComponent {...props} key={index + '_social'} />
            ) : (
                <a {...props} key={index + '_social'} aria-label={link.alt || 'Social link'}></a>
            );
        })}
    </div>
);
